import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { publishBusinessPriorities } from '../../api'

export const requestBusinessPrioritiesPublish = createAsyncThunk(
  'businessPriorities/publish',
  publishBusinessPriorities
)
